import React from "react";
import { NavLink } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-10 border-t border-slate-200 dark:border-slate-800">
      <div className="mx-auto max-w-6xl px-4 py-6 text-sm text-slate-600 dark:text-slate-300 flex flex-col md:flex-row items-center justify-between gap-3">
        <nav className="flex flex-col items-center md:items-start gap-1 text-center md:text-left">
          <NavLink to="/contact" className={({ isActive }) => isActive ? "font-medium text-slate-900 dark:text-slate-100" : "hover:underline"}>
            Contact Me
          </NavLink>
          <NavLink to="/affiliate-disclosure" className={({ isActive }) => isActive ? "font-medium text-slate-900 dark:text-slate-100" : "hover:underline"}>
            Affiliate Disclosure
          </NavLink>
          <NavLink to="/privacy" className={({ isActive }) => isActive ? "font-medium text-slate-900 dark:text-slate-100" : "hover:underline"}>
            Privacy Policy
          </NavLink>
          <NavLink to="/admin" className={({ isActive }) => `text-xs ${isActive ? "font-medium text-slate-900 dark:text-slate-100" : "opacity-75 hover:underline"}`}>
            Admin
          </NavLink>
        </nav>
        <div className="opacity-80 text-center md:text-right">© {new Date().getFullYear()} Somemas Recovery</div>
      </div>
    </footer>
  );
}